import { Injectable } from '@angular/core';
import { ApiBase } from '@apis/cas';
import { Observable } from 'rxjs';
import { SelectType } from '@apis/cas/generated';

@Injectable({ providedIn: 'root' })
export class SelectTypeEndpoints extends ApiBase {
  public getSelectTypes(): Observable<SelectType[]> {
    return this.get<SelectType[]>(`/game/${this.gameId}/schema/select-types`);
  }

  public getSelectType(selectTypeId: string): Observable<SelectType> {
    return this.get<SelectType>(`/game/${this.gameId}/schema/select-types/${selectTypeId}`);
  }

  public createSelectType(selectType: SelectType): Observable<SelectType> {
    return this.post<SelectType>(`/game/${this.gameId}/schema/select-types`, selectType);
  }

  public updateSelectType(selectType: SelectType): Observable<SelectType> {
    return this.put<SelectType>(`/game/${this.gameId}/schema/select-types/${selectType.typeId}`, selectType);
  }

  public deleteSelectType(selectTypeId: string, force = false): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/schema/select-types/${selectTypeId}`, {
      params: force ? { force: 'true' } : undefined,
    });
  }
}
